import { render, staticRenderFns } from "./DeliveryConfirmationPopUp.vue?vue&type=template&id=2acadc53&scoped=true"
import script from "./DeliveryConfirmationPopUp.vue?vue&type=script&lang=js"
export * from "./DeliveryConfirmationPopUp.vue?vue&type=script&lang=js"
import style0 from "./DeliveryConfirmationPopUp.vue?vue&type=style&index=0&id=2acadc53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acadc53",
  null
  
)

export default component.exports